export default "__VITE_ASSET__BGRmHmrz__"